import React, { useState } from "react";
import { motion } from "framer-motion";
import BackgroundAnimated from "../BackgroundAnimated/BackgroundAnimated";
import logo from "../../images/LogoOnlyAnimation.gif";
import logoOre from "../../images/OrevanLogo.png";
import { Formik } from "formik";

function ResetPassword() {
  const [gradientPosition, setGradientPosition] = useState({ x: 100, y: 100 });
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");
  const [errorConfirm, setErrorConfirm] = useState("");

  const handleMouseMove = (e) => {
    const rect = e.currentTarget.getBoundingClientRect();
    const x = ((e.clientX - rect.left) / rect.width) * 200;
    const y = ((e.clientY - rect.top) / rect.height) * 200;
    setGradientPosition({ x, y });
  };
  const togglePassword = () => {
    setShowPassword(!showPassword);
  };
  const toggleConfirmPassword = () => {
    setShowConfirmPassword(!showConfirmPassword);
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const passwordIsValid = password.length >= 8;
    const confirmPasswordIsValid = confirmPassword.length >= 8;

    if (!password) {
      setError("Required");
    } else if (!passwordIsValid) {
      setError("Password must be at least 8 characters long.");
    } else {
      setError("");
    }

    if (!confirmPassword) {
      setErrorConfirm("Required");
    } else if (!confirmPasswordIsValid) {
      setErrorConfirm("Password must be at least 8 characters long.");
    } else {
      setErrorConfirm("");
    }

    if (password !== confirmPassword) {
      setErrorConfirm("Passwords do not match.");
    }
  };

  return (
    <div className="relative overflow-hidden">
      <div className="h-screen w-screen bg-purpleColorSecond flex justify-center ">
        <motion.div
          initial={{
            opacity: 0,
          }}
          animate={{
            opacity: 1,
          }}
          transition={{
            duration: 2,
          }}
          className="min-h-screen flex items-center  justify-center  bg-darkPurple lg:w-2/5 rounded-3xl relative md:z-10"
        >
          <div className=" text-white p-6  w-full md:max-w-lg lg:max-w-2xl">
            <div className="relative z-10">
              <div className="flex justify-center ml-4 lg:ml-0 md:mb-3">
                <img src={logo} className="w-2/5  md:w-1/3" alt="" />
              </div>
              <p className="text-3xl lg:text-2xl 2xl:text-3xl font-bold text-center md:mb-8 md:mt-4">
                Reset Password
              </p>
              <div className="my-4">
                <Formik>
                  {() => (
                    <form onSubmit={handleSubmit}>
                      <div>
                        <div>
                          <div className="mt-2 mb-1 ">
                            <label className="text-lg font-medium ">
                              New Password
                            </label>
                            <div className="relative w-full">
                              <input
                                onChange={(e) => {
                                  setPassword(e.target.value);
                                  setError("");
                                }}
                                type={showPassword ? "text" : "password"}
                                name="password"
                                id="password"
                                placeholder="New Password.."
                                className="w-full  p-4 bg-transparentPurple text-grayColor placeholder-grayColor rounded-lg my-4"
                              />

                              <i
                                className={`fa-regular ${
                                  showPassword ? "fa-eye" : "fa-eye-slash"
                                } absolute right-3 top-1/2 transform -translate-y-1/2 cursor-pointer`}
                                onClick={togglePassword}
                              ></i>
                            </div>
                            <span className="text-red-600 ">{error}</span>
                          </div>
                        </div>
                        <div className="mt-2">
                          <label className="text-lg font-medium ">
                            Confirm New Password
                          </label>
                          <div className="relative w-full">
                            <input
                              onChange={(e) => {
                                setConfirmPassword(e.target.value);
                                errorConfirm("");
                              }}
                              type={showConfirmPassword ? "text" : "password"}
                              name="confirmPassword"
                              id="confirmPassword"
                              placeholder="Confirm Password.."
                              className="w-full p-4 bg-transparentPurple text-grayColor placeholder-grayColor rounded-lg my-4"
                            />

                            <i
                              className={`fa-regular ${
                                showConfirmPassword ? "fa-eye" : "fa-eye-slash"
                              } absolute right-3 top-1/2 transform -translate-y-1/2 cursor-pointer`}
                              onClick={toggleConfirmPassword}
                            ></i>
                          </div>
                          <span className="text-red-600">{errorConfirm}</span>
                        </div>
                      </div>

                      <div className="my-4 lg:flex lg:flex-col lg:justify-between md:h-64 2xl:h-80">
                        <div>
                          <motion.button
                            onMouseMove={handleMouseMove}
                            animate={{
                              backgroundPosition: `${gradientPosition.x}% ${gradientPosition.y}%`,
                            }}
                            type="submit"
                            className="bg-gradient-to-r from-greenColor to-greenColorLight text-white py-3 rounded-lg font-bold w-full hover:translate-x-[2px] hover:translate-y-[3px] transition-all duration-75 "
                            style={{
                              backgroundImage:
                                "radial-gradient(circle, #0F3C2B, #56EEB6)",
                              backgroundSize: "300% 300%",
                              transition: "background-position 0.2s ease",
                            }}
                            transition={{
                              duration: 1,
                            }}
                          >
                            <span>Sign In</span>
                          </motion.button>
                        </div>

                        <div>
                          <img
                            className="w-2/5  md:w-1/3 2xl:w-30 mx-auto mt-4"
                            src={logoOre}
                            alt=""
                          />
                        </div>
                      </div>
                    </form>
                  )}
                </Formik>
              </div>
            </div>
          </div>
        </motion.div>
        <BackgroundAnimated />
      </div>
    </div>
  );
}

export default ResetPassword;
